import { uuid } from 'common/utils';

// Matching buffer the backend adds to round times (mirrors backend Nattering.kt CREATE_NATTERING_ROOMS_TIMEOUT): clients receive the round ~10s before rooms exist.
export const MATCHING_ROOMS_BUFFER_MS = 10_000;

// Max countdown a viewer who received the round at ≈T0 (before rooms started) can have left — keeps the matching buffer. Skew backstop (HNS-147).
export const getRoundCountdownClampMs = (
  natteringRoundStartTime: number | undefined,
  natteringRoundEndTime: number | undefined
): number | undefined =>
  natteringRoundStartTime != null &&
  natteringRoundStartTime > 0 &&
  natteringRoundEndTime != null &&
  natteringRoundEndTime > natteringRoundStartTime
    ? natteringRoundEndTime - natteringRoundStartTime + MATCHING_ROOMS_BUFFER_MS
    : undefined;

export const BroadcastNotifications = {
  otherUserJoinedStage: {
    id: uuid(),
    getMessage: (name: string, speakersCount: number) =>
      speakersCount === 1 ? `${name} has joined the Stage` : `${name} +${speakersCount - 1} more have joined the Stage`,
  },
  currentUserLeftStage: {
    id: uuid(),
    getMessage: () => 'You have left the Stage',
  },
  otherUserLeftStage: {
    id: uuid(),
    getMessage: (name: string, speakersCount: number) =>
      speakersCount === 1 ? `${name} has left the Stage` : `${name} +${speakersCount - 1} more have left the Stage`,
  },
};
